import Vue from 'vue'

// jQuert & Bootstrap
window.Popper = require('popper.js').default;
window.$ = window.jQuery = require('jquery')
require('bootstrap')
require('jquery-mask-plugin')

// Axios
import axios from 'axios'
window.axios = axios

// Moment Js
import moment from 'moment-timezone'
window.moment = moment
window.clientTimeZone = moment.tz.guess();
Vue.prototype.$moment = window.moment;

// Lodash
import lodash from 'lodash'
window._ = lodash

// intlTelInput (Phone)
import intlTelInput from 'intl-tel-input'
window.intlTelInput = intlTelInput

// Flatpicker (Calendar)
import flatpickr from 'flatpickr'
window.flatpickr = flatpickr

// Signature Pad
window.SignaturePad = require('signature_pad').default;

// Dropzone
window.Dropzone = require('dropzone').default
Dropzone.autoDiscover = false;

// Pretty Bytes
window.prettyBytes = require('pretty-bytes');

// Pretty Checkbox
import PrettyCheckbox from 'pretty-checkbox-vue';
Vue.use(PrettyCheckbox);

// Toggle button
import ToggleButton from 'vue-js-toggle-button'
Vue.use(ToggleButton)
